module.exports = __webpack_public_path__ + "img/0.3ba99b6d.webp";